import React from 'react';

import { useNetworkState } from 'react-use';

import { alert } from '@components/ui/Alert';

export const useNetworkStatusNotification = () => {
  const { online, previous } = useNetworkState();
  const [isOfflineModalVisible, setIsOfflineModalVisible] =
    React.useState(false);

  React.useEffect(() => {
    const isOffline = online === false;
    const isReconnected = online === true && previous === false;

    if (isOffline) {
      setIsOfflineModalVisible(true);
    }

    if (isReconnected) {
      alert.success('Связь восстановлена');
      setIsOfflineModalVisible(false);
    }
  }, [online, previous]);

  return { isOfflineModalVisible };
};
